import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import style from './error-content.module.less';

const ErrorContent = ({ errorMessage = '' }) => {
  return (
    <div className={classnames(style['error-content'])}>
      <FontAwesomeIcon className={style.icon} icon={faExclamationCircle} />
      <div className={style.message}>{errorMessage}</div>
    </div>
  );
};

ErrorContent.propTypes = {
  errorMessage: PropTypes.string,
};

export default ErrorContent;
